import React, { createRef, PureComponent } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { Icon, InfiniteTable, DLMenu, ExternalLink } from 'appSrc/components/UI';
import TextTruncate from 'react-text-truncate';
import EditQRCodeModal from '../../Modals/QRCode/EditQRCodeModal';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';

class Table extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = {
            qrCodeInEdit: null,
            qrCodeInEditIndex: -1,
        };
    }

    updateQrCode =( index, id, data ) => {
        this.props.updateQRCode( id, data )
        .then( ( brand ) => {
            return this.props.onBrandUpdated && this.props.onBrandUpdated( index, brand );
        } );
    }

    openEditModal = ( index, qrCode ) => {
        this.setState( { qrCodeInEdit: qrCode, qrCodeInEditIndex: index } );
    }
    
    onEditSubmit = ( brand ) => {
        var index = this.state.qrCodeInEditIndex;
        this.props.onQRCodeUpdated( index, brand );
        this.setState( { qrCodeInEdit: null, qrCodeInEditIndex: -1 } );
    }

    onEditClose = () => {
        this.setState( { qrCodeInEdit: null, qrCodeInEditIndex: -1 } );
    }

    render() {
        const { rows } = this.props;

        return (
            <div>
                <InfiniteTable
                loadMore={ this.props.loadMore }
                elementHeight={ 70 }>
                    { this.arrayTableRows( rows ) }
                </InfiniteTable>
                { this.state.qrCodeInEdit &&
                    <EditQRCodeModal 
                    closeModal={ this.onEditClose }
                    onSubmit={ this.onEditSubmit }
                    qrCode={ this.state.qrCodeInEdit }
                    downloadQRCode={ this.downloadQRCode } />
                }
            </div>
        );
    }

    arrayTableRows = ( rows ) => {
        let tableRows = rows.map( ( row, index ) => {
            
            let individualSlug = `/admin/videos/${ row.id }`;

            return (
                <InfiniteTable.Row key={ row.id } className='dl-table-body'>
                    <InfiniteTable.Cell className={ style.title }>
                        <Link to={ individualSlug }></Link>
                        <TextTruncate text={ row.title }
                        line={ 2 } />
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        <ExternalLink to={ row.uri } className={ style.externalLink }>
                            { row.uri }
                        </ExternalLink>
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell className={ style.title }>
                        <Link to={ individualSlug }></Link>
                        { row.transcripts.length }
                    </InfiniteTable.Cell>
                </InfiniteTable.Row>
            );
        } );

        const currentSort = this.props.currentSort;
        const sortIcon = ( value ) => {
            if( currentSort == value ) {
                return (
                    <Icon source='fontAwesome'
                    icon='fas/faSortUp'
                    style={ { cursor: 'pointer' } }
                    onClick={ () => { this.props.onColumnSort( value ); } } />
                );
            }
            if( currentSort == `-${ value }` ) {
                return (
                    <Icon source='fontAwesome'
                    icon='fas/faSortDown'
                    style={ { cursor: 'pointer' } }
                    onClick={ () => { this.props.onColumnSort( value ); } } />
                );
            }
            return (
                <Icon source='fontAwesome'
                icon='fas/faSort'
                style={ { cursor: 'pointer' } }
                onClick={ () => { this.props.onColumnSort( value ); } } />
            );
        };

        tableRows.unshift( (
            <InfiniteTable.Row key='-1' className='dl-table-head'>
                <InfiniteTable.Cell>
                    TITLE { sortIcon( 'title,id' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    LINK { sortIcon( 'uri,id' ) }
                </InfiniteTable.Cell>
            </InfiniteTable.Row>
        ) );

        return tableRows;
    }
}

Table.defaultProps = {
    onBrandUpdated: ()=>{},
};

const mapDispatchToProps = () => {
    return {
        updateBrand: ( id, data ) => {
            return dAPI.patch( `/admin/brands/${ id }`, data );
        },
    };
};

export default connect( null, mapDispatchToProps )( Table );
